import React from "react";
import { useTranslation } from "react-i18next";
import {
    Filter,
    Form,
    Grid,
    useResourceApi,
    useBaseAppContext,
    numberFormat,
    numberFormatCurrency,
} from "@programari-limit/base-react";
import MuiGrid from "@mui/material/Grid";
import GridFormField from "components/GridFormField";
import { useNavigate, useParams } from "react-router";
import GridFilterField from "components/GridFilterField";
import {
    Box,
    Divider,
    Icon,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import { SpringFilterQueryBuilder } from "utils/spring-filter-query-builder";
import { columnesTripulant } from "sharedAdvancedSearch/advancedSearchColumns";

export const ControlFotografiaForm = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Form
            resourceName="controlFotografia"
            id={id}
            titleCreate={t("controlFotografia.create")}
            titleUpdate={t("controlFotografia.update")}
            onGoBack={() => navigate(id ? "../../" : "../")}
            readOnly
        >
            <MuiGrid container spacing={2} sx={{ mt: 1 }}>
                <GridFormField name="data" xs={2} />
                <GridFormField name="embarcacio" xs={3} />
                <GridFormField name="recurs" xs={3} />
                <GridFormField
                    name="fotograf"
                    xs={4}
                    advancedSearchColumns={columnesTripulant}
                />
                <GridFormField name="clauersFets" xs={2} />
                <GridFormField name="clauersVenuts" xs={2} />
                <GridFormField name="preuClauers" xs={2} />
                <GridFormField name="postalsFetes" xs={2} />
                <GridFormField name="postalsVenudes" xs={2} />
                <GridFormField name="preuPostals" xs={2} />
                <GridFormField name="importClauers" xs={2} />
                <GridFormField name="importPostals" xs={2} />
                <GridFormField name="importEfectiu" xs={2} />
                <GridFormField name="importTargeta" xs={2} />
                {/** TODO deshabilitar es camp importTotal, ja que es calcula amb un patch */}
                <GridFormField name="importTotal" xs={2} />
                {/** TODO deshabilitar es camp totalVenut, ja que es calcula amb un patch */}
                <GridFormField name="totalVenut" xs={2} />
                <GridFormField name="observacions" xs={12} />
            </MuiGrid>
        </Form>
    );
};

const TotalsContent = (props) => {
    const { totals } = props;
    const { t } = useTranslation();
    const { currentLanguage } = useBaseAppContext();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 1,
                mt: 1,
                mb: 2,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.clauersFets")}
                </Typography>
                <Typography>
                    {numberFormat(totals.clauersFets, null, currentLanguage)}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.clauersVenuts")}
                </Typography>
                <Typography>
                    {numberFormat(totals.clauersVenuts, null, currentLanguage)}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.importClauers")}
                </Typography>
                <Typography>
                    {numberFormatCurrency(
                        totals.importClauers,
                        "eur",
                        null,
                        currentLanguage,
                    )}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.postalsFetes")}
                </Typography>
                <Typography>
                    {numberFormat(totals.postalsFetes, null, currentLanguage)}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.postalsVenudes")}
                </Typography>
                <Typography>
                    {numberFormat(totals.postalsVenudes, null, currentLanguage)}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.importPostals")}
                </Typography>
                <Typography>
                    {numberFormatCurrency(
                        totals.importPostals,
                        "eur",
                        null,
                        currentLanguage,
                    )}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            {/* <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.totalVenut")}
                </Typography>
                <Typography>{totals.totalVenut}</Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.totalControlsFotografia")}
                </Typography>
                <Typography>{totals.totalControlsFotografia}</Typography>
            </Box>
            <Divider orientation="vertical" flexItem /> */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.importTargeta")}
                </Typography>
                <Typography>
                    {numberFormatCurrency(
                        totals.importTargeta,
                        "eur",
                        null,
                        currentLanguage,
                    )}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.importEfectiu")}
                </Typography>
                <Typography>
                    {numberFormatCurrency(
                        totals.importEfectiu,
                        "eur",
                        null,
                        currentLanguage,
                    )}
                </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    {t("controlFotografia.totals.importTotal")}
                </Typography>
                <Typography>
                    {numberFormatCurrency(
                        totals.importTotal,
                        "eur",
                        null,
                        currentLanguage,
                    )}
                </Typography>
            </Box>
        </Box>
    );
};

const FilterContent = (props) => {
    const { filterApiRef } = props;
    const { t } = useTranslation();

    return (
        <MuiGrid container spacing={2}>
            <GridFilterField name="dataInici" sm={6} md={4} lg={2.5} xl={2} />
            <GridFilterField name="dataFi" sm={6} md={4} lg={2.5} xl={2} />
            <GridFilterField
                name="embarcacio"
                sm={5}
                md={4}
                lg={3.25}
                xl={2.25}
            />
            <GridFilterField
                name="fotograf"
                xs={10}
                sm={6}
                md={5.5}
                lg={3}
                xl={3}
                advancedSearchColumns={columnesTripulant}
            />

            <MuiGrid item lg={0.5}>
                <Tooltip title={t("comu.resetFiltre")}>
                    <IconButton
                        onClick={() => filterApiRef?.current?.doReset()}
                    >
                        <Icon>filter_alt_off</Icon>
                    </IconButton>
                </Tooltip>
            </MuiGrid>
        </MuiGrid>
    );
};

const springFilterBuilder = (data) => {
    const { and, equal, ge, le } = SpringFilterQueryBuilder;

    const filter = and(
        ge("data", data?.dataInici ? data?.dataInici : undefined),
        le("data", data?.dataFi ? data?.dataFi : undefined),
        equal("embarcacio.id", data?.embarcacio?.id),
        equal("fotograf.id", data?.fotograf?.id),
    ).toString();

    return filter;
};

const ControlFotografiaFilter = (props) => {
    const { onSpringFilterChange, onFilterInitialized } = props;
    const filterApiRef = React.useRef();

    return (
        <Box sx={{ mb: 2 }}>
            <Filter
                name={"CF_FILTER"}
                resourceName={"controlFotografia"}
                persistentState
                springFilterBuilder={springFilterBuilder}
                onSpringFilterChange={onSpringFilterChange}
                onFilterInitialized={onFilterInitialized}
                size="small"
                apiRef={filterApiRef}
                initialOnChangeRequest
            >
                <FilterContent filterApiRef={filterApiRef} />
            </Filter>
        </Box>
    );
};

const ControlFotografia = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [fixedFilter, setFixedFilter] = React.useState();
    const [filterInitialized, setFilterInitialized] = React.useState(false);
    const { apiInitialized, exec: apiExec } =
        useResourceApi("controlFotografia");
    const [totals, setTotals] = React.useState();

    const columns = [
        { name: "data", flex: 1, minWidth: 100, maxWidth: 110 },
        { name: "embarcacio", flex: 1, minWidth: 120 },
        { name: "clauersFets", flex: 1, minWidth: 120 },
        { name: "clauersVenuts", flex: 1, minWidth: 120 },
        { name: "postalsFetes", flex: 1, minWidth: 120 },
        { name: "postalsVenudes", flex: 1, minWidth: 120 },
        { name: "importTargeta", flex: 1, minWidth: 120 },
        { name: "importEfectiu", flex: 1, minWidth: 120 },
        { name: "importTotal", flex: 1, minWidth: 120 },
        { name: "fotograf", flex: 1, minWidth: 150 },
        // { name: "observacions", flex: 1, minWidth: 120 },
    ];

    const obtenirTotals = () => {
        if (apiInitialized) {
            apiExec("exec_CF_OBTENIR_TOTALS", {
                data: { springFilter: fixedFilter ?? undefined },
                callbacks: {
                    setResponse: (response) => {
                        const resource = {
                            ...response.data,
                            _resource: response,
                            _links: response.links,
                        };
                        setTotals(resource);
                    },
                    setError: (error) => {},
                },
            });
        }
    };

    React.useEffect(() => {
        if (apiInitialized && filterInitialized) {
            obtenirTotals();
        }
    }, [apiInitialized, filterInitialized, fixedFilter]);

    const rowAdditionalActions = (params) => {
        const listActions = [
            {
                icon: "search", //visibility o search
                label: t("comu.detall"),
                onClick: () => navigate(`form/${params?.id}`),
            },
        ];
        return listActions;
    };

    return (
        <Grid
            title={t("controlFotografia.title")}
            resourceName="controlFotografia"
            columns={columns}
            fixedFilter={fixedFilter}
            findDisabled={!filterInitialized}
            readOnly
            formRoutePath="form"
            toolbarAdditionalRow={
                <>
                    <ControlFotografiaFilter
                        onSpringFilterChange={setFixedFilter}
                        onFilterInitialized={() => setFilterInitialized(true)}
                    />
                    {totals && <TotalsContent totals={totals} />}
                </>
            }
            rowAdditionalActions={(params) => rowAdditionalActions(params.row)}
            onRefresh={() => obtenirTotals()}
            onDelete={() => obtenirTotals()}
            density="compact"
            defaultSortModel={[{ field: "data", sort: "desc" }]}
        />
    );
};
export default ControlFotografia;
